import { render } from "./customer_field_dateofbirth.vue?vue&type=template&id=5188e3d2"
import script from "./customer_field_dateofbirth.vue?vue&type=script&lang=js"
export * from "./customer_field_dateofbirth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__